<div>
  <div class="mt-4">
    <!--    <div class="mb-3 flex items-center gap-4" [formGroup]="formSearch">-->
    <!--      <mat-form-field-->
    <!--        class="input-tg search-tg mt-message-input w-2/5"-->
    <!--        appearance="outline"-->
    <!--      >-->
    <!--        <mat-label>Pesquisa</mat-label>-->
    <!--        <input matInput formControlName="search" />-->
    <!--      </mat-form-field>-->
    <!--      <div>-->
    <!--        <button class="btn-icon" (click)="search()">-->
    <!--          <mat-icon>search</mat-icon>-->
    <!--        </button>-->
    <!--      </div>-->
    <!--    </div>-->
    @if (!loading) {
      <div>
        <table-list-permission
          [dataSource]="itemsList"
          [columns]="columns"
          [profile]="profile"
          (refreshList)="getPermissionbyProfile()"
        />
        <!--        <pagination-->
        <!--          [currentPage]="page"-->
        <!--          [pageSize]="rows"-->
        <!--          [totalRecords]="numberRows"-->
        <!--          (pageChanged)="pageChanged($event)"-->
        <!--        />-->
      </div>
    } @else {
      <div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
  </div>
</div>
